module.exports = __webpack_public_path__ + "img/upload-in-progress.59fe2e0e.png";